import React, { useState } from "react";

const Sidebar = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [responseMsg, setResponseMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg("");

    try {
      const res = await fetch(
        "https://karmyogienterprise.com/contact_api/sidebar_contact.php", // backend PHP file
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const result = await res.json();
      setResponseMsg(result.message);

      if (result.status === "success") {
        setFormData({ name: "", email: "", phone: "", message: "" });
      }
    } catch (error) {
      setResponseMsg("API Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="col-lg-4 mb-30">
      <div className="ca-sidebar-area ml-50">
        
        {/* Phone us */}
        <div className="ca-servic-list ca-padding cream-bg-3 br-7 mb-30">
          <h4 className="ca-title ca-servic-list-title fnw-600 theme-black-3 pb-24">
            Contact With Us
          </h4>
          <div className="ca-ph-content">
            <div className="ca-ph-ic">
              <span><img src="/static/img/icon/ca-ser-phone.svg" alt="" /></span>
            </div>
            <div className="ca-ph-title">
              <h4 className="ph-title"><a href="tel:+91 6352099433">+91 6352099433</a></h4>
            </div>
          </div>
        </div>

        {/* Sidebar contact */}
        <div className="ca-search ca-padding cream-bg-3 br-7 mb-30">
          <h4 className="ca-title fnw-600 theme-black-3 pb-24">Get A Free Quote</h4>
          <div className="ca-sidebar-form">
            <form onSubmit={handleSubmit}>
              <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
              <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
              <input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />
              <textarea name="message" rows={4} placeholder="Your Message" value={formData.message} onChange={handleChange} required />
              <button type="submit" className="ca-btn-primary-3 theme-bg-3 text-white br-50" disabled={loading}>
                {loading ? "Sending..." : "Send Now"} <span><i className="fa-solid fa-angle-right" /></span>
              </button>
            </form>
            {responseMsg && <p className="pt-3">{responseMsg}</p>}
          </div>
        </div>

        {/* Follow Us */}
        <div className="ca-search ca-padding cream-bg-3 br-7 mb-30">
          <h4 className="ca-title fnw-600 theme-black-3 pb-24">Follow Us</h4>
          <div className="ca-footer-social ca-footer-social-3">
            <ul>
              <li><a href="#"><i className="fa-brands fa-instagram" /></a></li>
              <li><a href="#"><i className="fa-brands fa-facebook-f" /></a></li>
              <li><a href="#"><i className="fa-brands fa-linkedin-in" /></a></li>
              <li><a href="#"><i className="fa-brands fa-x-twitter" /></a></li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Sidebar;
